

export default {
    props: {
        dataTop: {
            type: Object,
        },
    },

    components: {

    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
        }
    },
    watch: {
        dataTop(value) {
            this.dataTop = value
            this.initialize()

        },
    },
    methods: {
        async initialize() {
            console.log(this.dataTop)


        }
    }
}